import Commandbar from "~/components/planning/Commandbar"
import MultiEditDialog from "~/components/planning/MultiEditDialog/MultiEditDialog"
import { PurchaseOrderDialog } from "~/components/purchaseOrder/PurchaseOrderDialog"
import { useVariantsByIds } from "~/hooks/useVariants"
import { getCommonVendors } from "~/utils/vendorUtils"

type Props = {
  selectedVariantIds: string[]
  selectedVariantCount: number
  clearSelectedIds: () => void
}

export function MultiEditReplenishmentSuggestionsPanel({
  selectedVariantIds,
  selectedVariantCount,
  clearSelectedIds,
}: Props) {
  const variants = useVariantsByIds(selectedVariantIds)
  const skuIds = variants.flatMap((v) => v.skuIds)
  const commonVendors = getCommonVendors(variants)

  return (
    <>
      {selectedVariantCount > 0 && (
        <Commandbar count={selectedVariantCount} onClear={clearSelectedIds}>
          <MultiEditDialog
            selectedSkuIds={skuIds}
            selectedVariantCount={selectedVariantCount}
            resetSelectedProductIds={clearSelectedIds}
            commonVendors={commonVendors}
            triggerButtonVariant="neutral"
          />

          <PurchaseOrderDialog variants={variants} triggerButtonVariant="primary" />
        </Commandbar>
      )}
    </>
  )
}
